import { PdfFieldComponent } from '../../PdfComponent';
import React from 'react';
import { DropdownSearchSelect } from '../../../../components/Dropdown';
import { usePdfTemplateContext } from '../../PdfTemplateEditorContext';
import PdfTemplateComponentDefault from '../properties/PdfTemplateComponentDefault';
import PdfTemplateComponentFont from '../properties/PdfTemplateComponentFont';
import PdfTemplateComponentTextAlignment from '../properties/PdfTemplateComponentTextAlignment';
import PdfTemplateComponentBorder from '../properties/PdfTemplateComponentBorder';
import { PdfFieldResolving } from '../../data/PdfFieldResolving';
import { Checkbox } from '../../../../components/Checkbox';
import { TextInput } from '../../../../components/TextInput';
import { PdfDataKey } from '../../data/PdfDataKey';

interface PdfTemplateFieldComponentPropertiesProps {
  component: PdfFieldComponent;
}

export default function PdfTemplateFieldComponentProperties<T>({
  component,
}: PdfTemplateFieldComponentPropertiesProps) {
  const { dataKeys, updateComponent, data } = usePdfTemplateContext<T>();

  return (
    <div className='grid gap-2'>
      <PdfTemplateComponentDefault component={component} />

      <p className='section-title mt-2'>Style</p>
      <PdfTemplateComponentFont component={component} />
      <PdfTemplateComponentBorder component={component} />

      <p className='section-title mt-2'>Content</p>
      <DropdownSearchSelect<PdfDataKey<any>>
        placeholder={'Select field to populate'}
        items={dataKeys}
        textBuilder={key => PdfFieldResolving.getLabel(key, data)}
        onSelect={key => updateComponent(component.id, { key })}
        value={component.key}
        label={'Field to populate'}
      />
      <Checkbox
        label={'Customize'}
        value={component.format !== undefined}
        onChange={checked => updateComponent(component.id, { format: checked ? '{VALUE}' : undefined })}
      />
      {component.format !== undefined && (
        <TextInput
          label={'Custom format'}
          tooltip={'The {VALUE} must always be present as this is what will be replaced by your field to populate.'}
          value={component.format}
          onChange={value => value.includes('{VALUE}') && updateComponent(component.id, { format: value })}
        />
      )}
      <PdfTemplateComponentTextAlignment component={component} />
    </div>
  );
}
